import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton, Tooltip, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import logoTransparent from '../../assets/logo_transparent.png';

const BestPracticesDialog = () => {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <Tooltip title="Best Practices" arrow placement="bottom">
                <IconButton 
                    onClick={() => setOpen(true)}
                    sx={{ color: '#6B7280' }}
                    aria-label="best practices"
                >
                    <InfoIcon />
                </IconButton>
            </Tooltip>

            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        
                        <Typography sx={{ color: '#2B0063', fontWeight: 'bold', fontSize: '30px' }}>
                            Best Practices Guidelines
                        </Typography>
                        <img 
                            src={logoTransparent} 
                            alt="Best Practices" 
                            style={{ width: '160px', height: 'full' }} 
                        />
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h7" color="error" gutterBottom>
                        Please refer to the guidelines below to ensure your campaign is successful. Failure to do so will result in a blocked campaign and/or incurred charges.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ mt: 2, fontWeight: 'bold' }} color="#2B0063">Respectful Communication:</Typography>
                    <Typography paragraph>
                        • Ensure all communication is inclusive and professional.<br />
                        • Avoid offensive, discriminatory, or hateful language.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }} color="#2B0063">Prohibited Content Guidelines:</Typography>
                    <Typography paragraph>
                        • Avoid references to drugs, violence, explicit sexual content, or hate speech.<br />
                        • Avoid promoting excessive or irresponsible alcohol consumption.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }} color="#2B0063">Blast Frequency:</Typography>
                    <Typography paragraph>
                        • Limit messages to a maximum of 2 blasts per week to avoid spamming customers.<br />
                        • Ensure blasts are sent between 9am-9pm.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }} color="#2B0063">Message Structure Suggestions:</Typography>
                    <Typography paragraph>
                        • Include a clear call to action (e.g., "RSVP now" or "Show this text for 20% off").<br />
                        • SMS message limit is 160 characters (or 70 characters with emojis or special characters).<br />
                        <em style={{ display: 'block', marginTop: '16px', color:"#2B0063" }}>Disclaimer: Longer texts will count as multiple messages and incur double charges.</em>
                    </Typography>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default BestPracticesDialog; 